/* TODO fix cdk determineScrollbarWidth() to not do "parent.offsetHeight >= parent.scrollHeight" */
export function determineScrollbarWidth(parent: HTMLElement): number | null {
    const fill = document.createElement('div');
    fill.style.width = '100px';
    fill.style.height = '100px';

    const vp = document.createElement('div');
    vp.style.position = 'absolute';
    vp.style.top = '0';
    vp.style.left = '0';
    vp.style.width = '100px';
    vp.style.height = '100px';
    vp.style.overflow = 'hidden';
    vp.style.visibility = 'hidden';
    vp.appendChild(fill);

    parent.appendChild(vp);
    const w1 = fill.offsetWidth;
    vp.style.overflow = 'scroll';
    const w2 = w1 !== fill.offsetWidth ? fill.offsetWidth : vp.clientWidth;
    parent.removeChild(vp);

    const result = w1 - w2;
    if (isNaN(result) || result <= 0) {
        return null;
    }

    return result;
}
